var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid gap-4 ml-1"},[_c('label',{staticClass:"flex items-center px-12 py-18 mx-6 my-8 rounded cursor-pointer border-2 border-grey-300"},[_c('h5',{staticClass:"pl-12 text-sm font-semibold"},[_vm._v(" "+_vm._s(_vm.$t('rewards.reward_confirmation.no_contact_on_file'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }